import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
//import { httpGetOptions, httpJsonPostOptions } from '../../Util';

export const httpGetOptions = {
    headers: new HttpHeaders({
       
    })
  };
  export const httpJsonPostOptions = {
    headers: new HttpHeaders({
        'Content-Type':  'application/json',
        
    })
  };

  export const httpFormPostOptions = {
    headers: new HttpHeaders({
        'Content-Type':  'application/x-www-form-urlencoded'
        
    })
  };

@Injectable({
    providedIn: 'root'
})
export class EmailNoteService {
    constructor(private httpClient:HttpClient) { }
    httpHeaders = new HttpHeaders();
    backendUrl = environment.apiURLThread;

    getIncidentNotes(entityName,id):Observable<any> {
        //this.logService.logMessage('Section Groups','debug');
       
        return this.httpClient.get(this.backendUrl+'notes/'+entityName+'/'+id, httpGetOptions).pipe(retry(2), catchError(this.handleError));
    }
    onSaveEmailNote(entityName,id,payload):Observable<any> {
        return this.httpClient.post(this.backendUrl+'notes/'+entityName+'/'+id, payload, httpJsonPostOptions);
    }

    getContactByIncident(id){
        //ContactByIncident/402469
        return this.httpClient.get(this.backendUrl+'notes/ContactByIncident/'+id, httpGetOptions).pipe(retry(2), catchError(this.handleError));
    }

    private handleError(errorObj: HttpErrorResponse | any) {
        const _self = this;
        let errorMessage: string;
        let body: any;
        if (errorObj instanceof HttpErrorResponse) {
            if (errorObj.ok === false && errorObj.status === 0) {
                errorMessage = 'No internet connection or server might be unreachable. Please try again after sometime.';
            } else {
                body = errorObj.error || '';
                errorMessage = body.message ? body.message : body.error.message;
            }
        }
        return throwError(errorMessage);
    }
}